<template>
  <div class="mail-notice" :class="{ warning: state === 'error' }">
    <div class="mail-row"><div><strong>TAC-Daten</strong><br /><span v-if="syncedAt">Zuletzt aktualisiert: {{ formatDate(syncedAt, true) }}</span><span v-else>Noch nicht geladen</span></div>
      <button :disabled="busy || state === 'running'" @click="$emit('sync')">{{ busy || state === 'running' ? 'Wird synchronisiert …' : 'Jetzt synchronisieren' }}</button></div>
    <p v-if="error" class="mail-section" role="status">{{ error }}<span v-if="syncedAt"> Der letzte erfolgreiche Stand bleibt sichtbar.</span></p>
  </div>
</template>
<script>
import { formatDate } from "@/api/aiMails"
export default { props: { syncedAt: String, state: String, error: String, busy: Boolean }, methods: { formatDate } }
</script>
